import React from 'react';
import { useCSVDownloader } from 'react-papaparse';
import { Button } from 'react-md';


const SFCSVDownloadButton = (props) => {

    const { CSVDownloader } = useCSVDownloader();

    return (
        <div>
            <CSVDownloader
                data={props.data}
                filename={props.filename}
                bom={true}
                style={{
                    cursor: "pointer",
                    color: "blue",
                    textDecoration: "underline",
                }}
            >
                <Button primary raised>
                    {props.title}
                </Button>
            </CSVDownloader>
        </div>
    );
}

export default SFCSVDownloadButton;
